import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    phoneNumber: String
  }

  static targets = ["form", "name", "lastName", "email", "dni", "birthdate", "referral", "question"]

  connect() {
  }

  submit(event) {
    event.preventDefault()

    // Get form values
    const name = this.nameTarget?.value?.trim() || ""
    const lastName = this.lastNameTarget?.value?.trim() || ""
    const email = this.emailTarget?.value?.trim() || ""
    const dni = this.dniTarget?.value?.trim() || ""
    const birthdate = this.birthdateTarget?.value?.trim() || ""
    const referral = this.referralTarget?.value?.trim() || ""
    const question = this.questionTarget?.value?.trim() || ""

    // Validate required fields
    if (!name || !lastName || !email || !dni || !birthdate || !referral || !question) {
      alert("Por favor, completa todos los campos obligatorios.")
      return
    }

    // Validate phone number
    if (!this.phoneNumberValue) {
      alert("Error: Número de WhatsApp no configurado. Por favor, contacta al administrador.")
      return
    }

    // Build the message
    const message = this.buildMessage(name, lastName, email, dni, birthdate, referral, question)

    // Build WhatsApp Web URL
    const encodedMessage = encodeURIComponent(message)
    const whatsappUrl = `https://wa.me/${this.phoneNumberValue}?text=${encodedMessage}`

    // Track form submission in GA4
    if (typeof gtag === 'function') {
      gtag('event', 'homepage_form_submit', {
        event_category: 'conversion',
        event_label: 'whatsapp_inquiry',
        referral_source: referral
      })
    }

    // Open WhatsApp Web
    window.open(whatsappUrl, '_blank')

    // Optionally reset the form
    this.resetForm()
  }

  buildMessage(name, lastName, email, dni, birthdate, referral, question) {
    return `Hola! ${question}

Les dejo mi información de contacto:

- Nombre: ${name} ${lastName}
- DNI: ${dni}
- Fecha de nacimiento: ${birthdate}
- Email: ${email}
- Recomendado por: ${referral}
`
  }

  resetForm() {
    if (this.nameTarget) this.nameTarget.value = ""
    if (this.lastNameTarget) this.lastNameTarget.value = ""
    if (this.emailTarget) this.emailTarget.value = ""
    if (this.dniTarget) this.dniTarget.value = ""
    if (this.birthdateTarget) this.birthdateTarget.value = ""
    if (this.referralTarget) this.referralTarget.value = ""
    if (this.questionTarget) this.questionTarget.value = ""
  }
}
